enum ACTION_NAME {
  GET_DOCS = 'get-docs',
  CREDIT_APP = 'credit-app',
  CO_SIGNER = 'co-signer',
} export default ACTION_NAME;
